var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 381,
    height: 381,
    viewBox: "0 0 381 381",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 190.212,
    cy: 190.212,
    r: 133.5,
    transform: "rotate(45 190.212 190.212)",
    stroke: "url(#paint0_linear_110_2)",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.712,
    cy: 200.712,
    r: 123,
    stroke: "url(#paint1_linear_110_2)",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 196.712,
    cy: 211.712,
    r: 112,
    transform: "rotate(45 196.712 211.712)",
    stroke: "url(#paint2_linear_110_2)",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.712,
    cy: 223.712,
    r: 100,
    transform: "rotate(60 190.712 223.712)",
    stroke: "url(#paint3_linear_110_2)",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.212,
    cy: 236.212,
    r: 87.5,
    stroke: "url(#paint4_linear_110_2)",
    strokeWidth: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.212,
    cy: 248.212,
    r: 75.5,
    transform: "rotate(60 193.212 248.212)",
    stroke: "url(#paint5_linear_110_2)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_110_2",
    x1: 190.212,
    y1: 55.7117,
    x2: 190.212,
    y2: 324.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D662F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_110_2",
    x1: 251.5,
    y1: 170.5,
    x2: 141.5,
    y2: 177.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1909,
    stopColor: "#C67EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.642729,
    stopColor: "#FF4747"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_110_2",
    x1: 196.712,
    y1: 98.7117,
    x2: 196.712,
    y2: 324.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E57EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D662F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_110_2",
    x1: 190.712,
    y1: 122.712,
    x2: 190.712,
    y2: 324.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_110_2",
    x1: 190.212,
    y1: 147.712,
    x2: 190.212,
    y2: 324.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E57EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D662F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_110_2",
    x1: 193.212,
    y1: 171.712,
    x2: 193.212,
    y2: 324.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD8EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36285"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRings);
export default __webpack_public_path__ + "static/media/rings.af0b87dd2ebb1dcef6cecafe55cc0856.svg";
export { ForwardRef as ReactComponent };